import React, { useMemo } from "react";
import { cn } from "../../../../Utils/helper";
import StepQuestComplete from "./StepQuestComplete";
import { Navigate, useLocation } from "react-router-dom";
import Header from "../../../../components/v6/Header";

const StepRewardPending = () => {
  const location = useLocation();
  const { questDetailsData } = location.state || {};

  const mockResponseAnswer = useMemo(() => {
    if (!questDetailsData) return null;

    const { quest_business, reward_stickers } = questDetailsData;

    return {
      data: {
        add_token: quest_business?.token ? Number(quest_business.token) : 0,

        add_xp: quest_business?.xp ? Number(quest_business.xp) : 0,

        awarded_stickers: Array.isArray(reward_stickers) ? reward_stickers : [],

        is_completed: true,
        origin_level: {},
        origin_xp: 0,
        origin_token: 0,
        bonus_xp: 0,
        bonus_token: 0,
      },
    };
  }, [questDetailsData]);

  if (!questDetailsData) {
    return <Navigate to="/quest" replace />;
  }
  return (
    <div
      className={cn(
        "flex flex-col mx-auto w-full max-w-[480px] overflow-hidden bg-[#E1D2F3] "
      )}
    >
      <div
        className="sticky top-0 left-0 w-full z-50 "
        style={{
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(2px)",
          WebkitBackdropFilter: "blur(2px)",
        }}
      >
        {/* Import Header của bạn nếu cần */}
        <Header backgroundHeader="bg-transparent" />
      </div>
      <div className="flex flex-col min-h-screen pt-safe ">
        <div className="flex flex-col w-[calc(368px-60px)] justify-start pt-[40px] xs:justify-center 2xs:w-[368px]  items-center flex-1 mx-auto scrollbar-hide pb-safe mb-[126px]">
          <div className="w-full">
            <StepQuestComplete
              referral={true}
              responseAnswer={mockResponseAnswer}
              questDetailsData={questDetailsData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepRewardPending;
